export const XP_STEP = 5;

const clampNonNegative = (value: number): number => (value < 0 ? 0 : value);

export type LevelProgress = {
  level: number;
  xp: number;
  currentLevelMin: number;
  nextLevelMin: number;
  progress: number; // 0-1
  remaining: number;
};

export const xpForLevel = (level: number): number => {
  if (level <= 1) return 0;
  // Cumulative growing increments: costs 5, 15, 30, 50, ...
  return (XP_STEP * (level - 1) * level) / 2;
};

export const getLevelProgress = (xpRaw: number): LevelProgress => {
  const xp = clampNonNegative(Math.floor(xpRaw));

  // Find level by increasing threshold; levels start at 1.
  let level = 1;
  while (xp >= xpForLevel(level + 1)) {
    level += 1;
  }

  const currentLevelMin = xpForLevel(level);
  const nextLevelMin = xpForLevel(level + 1);
  const span = nextLevelMin - currentLevelMin || XP_STEP;
  const gainedInLevel = xp - currentLevelMin;
  const progress = Math.min(1, Math.max(0, gainedInLevel / span));
  const remaining = Math.max(0, nextLevelMin - xp);

  return {
    level,
    xp,
    currentLevelMin,
    nextLevelMin,
    progress,
    remaining,
  };
};

export const willLevelUp = (currentXp: number, gained: number): boolean => {
  const before = getLevelProgress(currentXp).level;
  const after = getLevelProgress(currentXp + gained).level;
  return after > before;
};

